import { render } from "./Entitlement.vue?vue&type=template&id=0ec2cd2e"
import script from "./Entitlement.vue?vue&type=script&lang=js"
export * from "./Entitlement.vue?vue&type=script&lang=js"

import "./Entitlement.vue?vue&type=style&index=0&id=0ec2cd2e&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__